export default {
    appAuth: "d29ya3N0YXRpb258NzNmZWEwZjNiNWI4NDViOGFiOTdlNjk2MzkzOWM4ZjQ=",
    title: "预约管理平台",
    logo:"/img/logo.png"
}